// extracted by mini-css-extract-plugin
export var contentRow = "BlogContent-module--contentRow--855a3";